export default "__VITE_ASSET__d65c99aa__"